import { useState, useEffect, useCallback } from "react";
import api from "../api";

const ORANGE = "#EE6A1A";
const VERDE = "#1D9E75";
const VERM = "#e2445c";
const AZUL = "#579bfc";

const dois = (n) => String(n).padStart(2, "0");
const fmtData = (d) => { if (!d) return "—"; const x = new Date(d); return dois(x.getDate()) + "/" + dois(x.getMonth() + 1) + "/" + x.getFullYear(); };
const fmtQuando = (d) => { if (!d) return "—"; const x = new Date(d); return fmtData(d) + " às " + dois(x.getHours()) + ":" + dois(x.getMinutes()); };

const NOMES = {
  Agendamento: "Horários na agenda",
  Pacote: "Pacotes de sessões",
  Orcamento: "Orçamentos",
  Lancamento: "Lançamentos financeiros",
  Notificacao: "Avisos internos",
  ListaEspera: "Lista de espera",
  Atividade: "Atividades e contatos",
  Comissao: "Comissões",
  Consentimento: "Consentimentos",
};
const rotuloModelo = (m) => NOMES[m] || m;

const CANAIS = [
  ["presencial", "Presencial"],
  ["whatsapp", "WhatsApp"],
  ["papel", "Papel assinado"],
  ["site", "Site"],
  ["telefone", "Telefone"],
  ["outro", "Outro"],
];

const card = { background: "var(--card-bg)", border: "1px solid var(--border-color)", borderRadius: 14, padding: 22, marginBottom: 18 };
const inp = { width: "100%", boxSizing: "border-box", padding: "10px 12px", borderRadius: 9, border: "1px solid var(--border-color)", background: "var(--input-bg)", color: "var(--text-primary)", fontSize: 13, fontFamily: "'Inter',sans-serif", outline: "none" };
const lbl = { fontSize: 11, fontWeight: 600, color: "var(--text-secondary)", marginBottom: 5, display: "block", textTransform: "uppercase", letterSpacing: ".04em" };
const btn = (primario, cor) => ({
  padding: "10px 18px", borderRadius: 9, border: primario ? 0 : "1px solid " + (cor ? cor + "66" : "var(--border-color)"),
  background: primario ? (cor || ORANGE) : "transparent", color: primario ? "#fff" : (cor || "var(--text-secondary)"),
  fontWeight: 700, fontSize: 13, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap",
});

// ─────────────────────────────── registrar consentimento

function ModalConsentimento({ pessoa, onFechar, onSalvo }) {
  const [f, setF] = useState({ canal: "presencial", finalidade: "atendimento", texto: "", versao: "", concedido: true });
  const [salvando, setSalvando] = useState(false);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));

  const salvar = async () => {
    setSalvando(true);
    try { await api.post(`/privacidade/${pessoa._id}/consentimento`, f); onSalvo(); }
    catch (e) { window.alert((e.response && e.response.data && e.response.data.message) || "Não foi possível registrar."); }
    finally { setSalvando(false); }
  };

  return (
    <div onClick={onFechar} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 1000, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "40px 16px", overflowY: "auto" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "var(--card-bg)", borderRadius: 14, padding: 24, width: "100%", maxWidth: 520, boxShadow: "0 20px 60px rgba(0,0,0,.25)" }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: "var(--text-primary)" }}>Registrar consentimento</div>
        <p style={{ fontSize: 12.5, color: "var(--text-muted)", margin: "4px 0 18px", lineHeight: 1.5 }}>
          É a prova de que {pessoa.nome} autorizou o uso dos dados dela. Guarde o canal e, se houver, o texto que ela leu.
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
          <div>
            <label style={lbl}>Como foi colhido</label>
            <select value={f.canal} onChange={(e) => set("canal", e.target.value)} style={{ ...inp, appearance: "auto" }}>
              {CANAIS.map(([id, r]) => <option key={id} value={id}>{r}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>Finalidade</label>
            <input value={f.finalidade} onChange={(e) => set("finalidade", e.target.value)} placeholder="atendimento" style={inp} />
          </div>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={lbl}>Texto ou versão do termo (opcional)</label>
          <textarea value={f.texto} onChange={(e) => set("texto", e.target.value)} style={{ ...inp, minHeight: 70, resize: "vertical" }}
            placeholder="Cole aqui o termo que a paciente assinou ou leu, ou descreva o que foi autorizado." />
        </div>

        <label style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 18, cursor: "pointer", fontSize: 13, color: "var(--text-primary)" }}>
          <input type="checkbox" checked={f.concedido} onChange={(e) => set("concedido", e.target.checked)} />
          Autorizou (desmarque para registrar uma recusa)
        </label>

        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onFechar} style={btn(false)}>Cancelar</button>
          <button onClick={salvar} disabled={salvando} style={btn(true)}>{salvando ? "Salvando…" : "Registrar"}</button>
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────── tela

export default function Privacidade() {
  const [busca, setBusca] = useState("");
  const [resultados, setResultados] = useState([]);
  const [sel, setSel] = useState(null);
  const [d, setD] = useState(null);
  const [erro, setErro] = useState("");
  const [ocupado, setOcupado] = useState(false);
  const [modal, setModal] = useState(false);
  const [trilha, setTrilha] = useState([]);

  useEffect(() => {
    if (busca.trim().length < 2) { setResultados([]); return; }
    const id = setTimeout(() => {
      api.get("/privacidade/buscar", { params: { q: busca } })
        .then(({ data }) => setResultados(data.lista || []))
        .catch(() => setResultados([]));
    }, 300);
    return () => clearTimeout(id);
  }, [busca]);

  const carregar = useCallback((id) => {
    setErro("");
    api.get(`/privacidade/${id}`)
      .then(({ data }) => { setD(data); setSel(id); })
      .catch((e) => setErro((e.response && e.response.data && e.response.data.message) || "Não foi possível carregar."));
  }, []);

  const carregarTrilha = useCallback(() => {
    api.get("/privacidade/trilha/tudo").then(({ data }) => setTrilha(data.lista || [])).catch(() => {});
  }, []);
  useEffect(() => { carregarTrilha(); }, [carregarTrilha]);

  const exportar = async () => {
    setOcupado(true);
    try {
      const { data } = await api.get(`/privacidade/${sel}/exportar`);
      const nome = String(d.pessoa.nome || "dados").replace(/[^\w\s-]/g, "").trim().replace(/\s+/g, "-").toLowerCase();
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = "dados-" + nome + ".json";
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 2000);
      carregarTrilha();
    } catch (e) { window.alert("Não foi possível exportar."); }
    finally { setOcupado(false); }
  };

  const anonimizar = async () => {
    if (!window.confirm(
      "Anonimizar " + d.pessoa.nome + "?\n\n" +
      "O nome, telefone e e-mail somem de todos os registros. O histórico de atendimentos e os valores continuam, sem identificação.\n\n" +
      "Isso não tem volta.")) return;
    setOcupado(true);
    try {
      const { data } = await api.post(`/privacidade/${sel}/anonimizar`);
      window.alert("Pronto. Agora aparece como " + data.apelido + ". Registros ajustados: " + data.registrosAjustados + ".");
      carregar(sel); carregarTrilha();
    } catch (e) { window.alert((e.response && e.response.data && e.response.data.message) || "Não foi possível anonimizar."); }
    finally { setOcupado(false); }
  };

  const excluir = async () => {
    const r = window.prompt(
      "EXCLUIR DE VEZ os dados de " + d.pessoa.nome + "?\n\n" +
      "Tudo será apagado: cadastro, horários, pacotes, orçamentos e consentimentos. Não dá para desfazer.\n" +
      "Antes disso, exporte os dados se precisar guardar cópia.\n\n" +
      "Digite EXCLUIR para confirmar:");
    if (r !== "EXCLUIR") return;
    setOcupado(true);
    try {
      const { data } = await api.delete(`/privacidade/${sel}`, { data: { confirmacao: "EXCLUIR" } });
      window.alert("Excluído.\n" + (data.apagados || []).join("\n"));
      setSel(null); setD(null); setBusca(""); carregarTrilha();
    } catch (e) { window.alert((e.response && e.response.data && e.response.data.message) || "Não foi possível excluir."); }
    finally { setOcupado(false); }
  };

  const revogar = async (c) => {
    if (!window.confirm("Registrar que o consentimento foi revogado?")) return;
    try { await api.post(`/privacidade/consentimento/${c._id}/revogar`); carregar(sel); carregarTrilha(); }
    catch (e) { window.alert("Não foi possível."); }
  };

  const ultimo = d && d.consentimentos && d.consentimentos.length ? d.consentimentos[0] : null;
  const temConsentimento = ultimo && ultimo.concedido && !ultimo.revogadoEm;

  return (
    <div style={{ padding: 24, fontFamily: "'Inter',-apple-system,sans-serif", background: "var(--page-bg)", minHeight: "100vh" }}>
      <div style={{ marginBottom: 18 }}>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "var(--text-primary)" }}>Privacidade</h1>
        <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--text-muted)", maxWidth: 680, lineHeight: 1.5 }}>
          Atende os pedidos que a LGPD dá ao titular: ver tudo que o sistema guarda, receber uma cópia, corrigir, anonimizar ou apagar.
        </p>
      </div>

      <div style={card}>
        <label style={lbl}>Buscar pessoa por nome, telefone ou e-mail</label>
        <input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Digite pelo menos duas letras" style={inp} autoFocus />

        {resultados.length > 0 && (
          <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 6 }}>
            {resultados.map((p) => (
              <button key={p._id} onClick={() => { carregar(p._id); setResultados([]); setBusca(p.nome); }}
                style={{ textAlign: "left", padding: "10px 12px", borderRadius: 9, border: "1px solid var(--border-color)", background: sel === p._id ? "var(--hover-bg)" : "transparent", cursor: "pointer", fontFamily: "inherit" }}>
                <div style={{ fontSize: 13.5, fontWeight: 600, color: "var(--text-primary)" }}>{p.nome}</div>
                <div style={{ fontSize: 12, color: "var(--text-secondary)", marginTop: 2 }}>
                  {[p.telefone, p.email].filter(Boolean).join(" · ") || "sem contato"} · cadastrada em {fmtData(p.createdAt)}
                </div>
              </button>
            ))}
          </div>
        )}
        {busca.trim().length >= 2 && !resultados.length && !d && (
          <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 12 }}>Ninguém encontrado com esse termo.</div>
        )}
      </div>

      {erro && <div style={{ ...card, fontSize: 13, color: VERM }}>{erro}</div>}

      {d && (
        <>
          <div style={card}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
              <div>
                <div style={{ fontSize: 17, fontWeight: 800, color: "var(--text-primary)" }}>{d.pessoa.nome}</div>
                <div style={{ fontSize: 12.5, color: "var(--text-secondary)", marginTop: 3 }}>
                  {[d.pessoa.telefone, d.pessoa.email].filter(Boolean).join(" · ") || "sem contato"} · cadastrada em {fmtData(d.pessoa.criadoEm)}
                </div>
              </div>
              {d.pessoa.anonimizado
                ? <span style={{ fontSize: 12, fontWeight: 700, color: AZUL, background: AZUL + "18", borderRadius: 7, padding: "6px 12px" }}>Anonimizada em {fmtData(d.pessoa.anonimizadoEm)}</span>
                : <span style={{ fontSize: 12, fontWeight: 700, color: temConsentimento ? VERDE : "#b45309", background: (temConsentimento ? VERDE : "#b45309") + "18", borderRadius: 7, padding: "6px 12px" }}>
                    {temConsentimento ? "Com consentimento" : "Sem consentimento registrado"}
                  </span>}
            </div>

            <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text-primary)", marginBottom: 8 }}>O que o sistema guarda sobre ela</div>
            {!d.relacionados.length && <div style={{ fontSize: 13, color: "var(--text-muted)" }}>Só o cadastro, sem registros ligados.</div>}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              {d.relacionados.map((r) => (
                <span key={r.modelo} style={{ fontSize: 12.5, color: "var(--text-primary)", background: "var(--hover-bg)", borderRadius: 8, padding: "7px 12px" }}>
                  {rotuloModelo(r.modelo)} <b>{r.total}</b>
                </span>
              ))}
            </div>

            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 20 }}>
              <button onClick={exportar} disabled={ocupado} style={btn(true)}>Exportar tudo</button>
              <button onClick={() => setModal(true)} disabled={ocupado} style={btn(false)}>Registrar consentimento</button>
              {!d.pessoa.anonimizado && <button onClick={anonimizar} disabled={ocupado} style={btn(false, AZUL)}>Anonimizar</button>}
              <button onClick={excluir} disabled={ocupado} style={btn(false, VERM)}>Excluir de vez</button>
            </div>

            <div style={{ marginTop: 14, fontSize: 12, color: "var(--text-muted)", lineHeight: 1.6 }}>
              <b style={{ color: "var(--text-secondary)" }}>Anonimizar</b> apaga a identificação e mantém o histórico de atendimentos e os valores — os relatórios continuam certos.{" "}
              <b style={{ color: "var(--text-secondary)" }}>Excluir</b> apaga tudo, inclusive o histórico. Guarde atenção ao prazo legal de guarda de documentos fiscais antes de excluir.
            </div>
          </div>

          <div style={card}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text-primary)", marginBottom: 12 }}>Consentimentos</div>
            {!d.consentimentos.length && (
              <div style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.5 }}>
                Nenhum registrado. Para dado de saúde, a autorização é o que sustenta o tratamento — registre assim que a paciente assinar ou concordar.
              </div>
            )}
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {d.consentimentos.map((c) => (
                <div key={c._id} style={{ display: "flex", gap: 12, alignItems: "center", padding: "11px 13px", borderRadius: 9, background: "var(--hover-bg)", flexWrap: "wrap" }}>
                  <span style={{ fontSize: 11, fontWeight: 700, color: c.concedido && !c.revogadoEm ? VERDE : VERM, background: (c.concedido && !c.revogadoEm ? VERDE : VERM) + "18", borderRadius: 6, padding: "3px 8px" }}>
                    {c.revogadoEm ? "revogado" : (c.concedido ? "autorizou" : "recusou")}
                  </span>
                  <span style={{ fontSize: 12.5, color: "var(--text-secondary)" }}>{fmtQuando(c.em)}</span>
                  <span style={{ fontSize: 12.5, color: "var(--text-primary)", flex: 1, minWidth: 120 }}>
                    {(CANAIS.find((x) => x[0] === c.canal) || [])[1] || c.canal} · {c.finalidade}
                    {c.registradoPor ? " · por " + c.registradoPor : ""}
                  </span>
                  {c.concedido && !c.revogadoEm && <button onClick={() => revogar(c)} style={{ ...btn(false), padding: "6px 12px", fontSize: 12 }}>Revogar</button>}
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      <div style={card}>
        <div style={{ fontSize: 14, fontWeight: 700, color: "var(--text-primary)" }}>Trilha de auditoria</div>
        <div style={{ fontSize: 12.5, color: "var(--text-muted)", margin: "3px 0 12px" }}>
          Toda ação de privacidade fica registrada com autor e data. É o que você mostra se a ANPD ou a paciente pedir explicação.
        </div>
        {!trilha.length && <div style={{ fontSize: 13, color: "var(--text-muted)" }}>Nenhuma ação registrada ainda.</div>}
        <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
          {trilha.map((l) => (
            <div key={l._id} style={{ display: "flex", gap: 12, alignItems: "baseline", padding: "9px 12px", borderRadius: 9, background: "var(--hover-bg)", flexWrap: "wrap" }}>
              <span style={{ fontSize: 12, color: "var(--text-secondary)", whiteSpace: "nowrap" }}>{fmtQuando(l.createdAt)}</span>
              <span style={{ fontSize: 12.5, color: "var(--text-primary)", flex: 1, minWidth: 160 }}>{l.titulo}</span>
              <span style={{ fontSize: 12, color: "var(--text-muted)" }}>{l.nomeUsuario || "—"}</span>
              {l.descricao && <span style={{ fontSize: 11.5, color: "var(--text-muted)", width: "100%" }}>{l.descricao}</span>}
            </div>
          ))}
        </div>
      </div>

      {modal && d && <ModalConsentimento pessoa={d.pessoa} onFechar={() => setModal(false)} onSalvo={() => { setModal(false); carregar(sel); carregarTrilha(); }} />}
    </div>
  );
}
